<template>
  <b-row v-if="method === 1 || method === 2">
    <!-- Input Template ID -->
    <b-col md="6">
      <b-form-group label="Template ID" label-for="template-id">
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <b-col md="9" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="template id"
                rules="required"
              >
                <b-form-input
                  id="template-id"
                  v-model="content.action_link"
                  placeholder="Input Template ID"
                  rows="3"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- <b-col md="3 pl-0 pl-md-1">
              <b-button class="btn-saveState w-100">Create</b-button>
            </b-col> -->
          </div>
        </div>
      </b-form-group>
    </b-col>
    <!-- End Input Template ID -->
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BContainer,
} from "bootstrap-vue";
import { ValidationProvider, extend } from "vee-validate";

extend("max11", (value) => {
  if (value.length <= 11) {
    return true;
  }
  return "The {_field_} field must be max 11 char";
});

extend("max130", (value) => {
  if (value.length <= 130) {
    return true;
  }
  return "The {_field_} field must be max 130 char";
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BFormTextarea,
    BButton,
    BContainer,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      content: {
        campaign_text: "",
        sender_name: "",
        action_link: "",
      },
      maxCount: 130,
      remainingCount: 130,
    };
  },
  methods: {
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content;
    },
    countdown() {
      this.remainingCount = Math.max(
        0,
        this.maxCount - this.content.campaign_text.length
      );
    },
  },
};
</script>
<style scoped>
.btn-saveState {
  background: #32bcad !important;
  border-color: #32bcad !important;
}
.btn-saveState:hover {
  box-shadow: 0 8px 25px -8px #32bcad !important;
}

.btn-PlusState {
  background: #32bcad;
  color: white;
  outline: none;
  border: 1px solid #32bcad;
  border-radius: 4px;
  margin-right: 2px;
}
.btn-MinusState {
  background: #ed1c24;
  color: white;
  outline: none;
  border: 1px solid #ed1c24;
  border-radius: 4px;
  margin-left: 2px;
}

.card-reviewState {
  border: 1px solid #d8d6de;
}

@media screen and (min-width: 768px) {
  .container-statementvalue {
    display: grid;
    grid-template-columns: 1.8fr 1fr 0.2fr;
  }
}
</style>
